/* ─────────────────────────────────────────
   KUNDA — Image utilities
   Shared by the Short-Stay wizard (App.js) and the
   Long-Term wizard (longterm.js).
───────────────────────────────────────── */

/* Compress + resize an image file to WebP (JPEG fallback).
   Returns the original file if anything fails or isn't smaller. */
export function compressImage(file, maxWidth, quality) {
  return new Promise(function(resolve) {
    try {
      if (!file || !file.type || file.type.indexOf("image/") !== 0) {
        resolve(file);
        return;
      }
      var reader = new FileReader();
      reader.onload = function(ev) {
        var img = new Image();
        img.onload = function() {
          try {
            var w = img.width;
            var h = img.height;
            if (w > maxWidth) {
              h = Math.round(h * (maxWidth / w));
              w = maxWidth;
            }
            var canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            /* WebP is 25–35% smaller than JPEG at the same quality, and
               universally supported on modern mobile browsers. If a (very old)
               browser can't encode WebP, toBlob returns null and we fall back. */
            canvas.toBlob(function(blob) {
              if (blob && blob.size > 0 && blob.size < file.size) {
                resolve(blob);
              } else {
                /* WebP unsupported or not smaller — try JPEG, then original */
                canvas.toBlob(function(jpg) {
                  if (jpg && jpg.size > 0 && jpg.size < file.size) resolve(jpg);
                  else resolve(file);
                }, "image/jpeg", quality);
              }
            }, "image/webp", quality);
          } catch (err) {
            resolve(file);
          }
        };
        img.onerror = function() { resolve(file); };
        img.src = ev.target.result;
      };
      reader.onerror = function() { resolve(file); };
      reader.readAsDataURL(file);
    } catch (err) {
      resolve(file);
    }
  });
}

/* File extension matching the compressed blob's actual type */
export function extForBlob(blob) {
  if (blob && blob.type === "image/webp") return ".webp";
  if (blob && blob.type === "image/jpeg") return ".jpg";
  return "";
}